<template>
  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4">
      <div
        v-for="estrategia in estrategias"
        class="tarjeta"
        :style="{ 'background-image': `url('${estrategia.foto_1}')` }"
        :key="estrategia.id"
        @click="entrar(estrategia.slug)"
      >
        <div class="texto">
          <p>{{ estrategia.name }}</p>
          <span>{{ estrategia.descripcion }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      estrategias: "getEstrategias"
    })
  },
  methods: {
    entrar(slug) {
      this.$router.push(slug);
    }
  }
};
</script>

<style lang="scss" scoped>
.tarjeta {
  // width: 300px;
  height: 160px;
  border-radius: 15px;
  margin: 15px;
  cursor: pointer;
  transition: box-shadow 300ms, transform 300ms;
  box-shadow: 0px 0px 7px -2px rgba(0, 0, 0, 0.5);
  // transform: scale(0.98);
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 0px 0px 5px black;
  overflow: hidden;
  background-color: rgb(0, 102, 170);
}

.tarjeta:hover {
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);
  // transform: scale(1);
}

.texto {
  // width: calc(100% - 20px);
  // width: calc(100% - 20px);
  width: 100%;
  height: 100%;
  // backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.65);
  transform: translateY(110px);
  transition: transform 300ms;
  border-radius: 15px;
  padding: 10px;
}

.tarjeta:hover .texto {
  transform: translateY(0px);
}

.tarjeta > .texto > p {
  font-size: 18pt;
}
</style>
